import React, { createContext, useState } from "react";

import { formatDate } from "../../../../utils/formatDate";
import { GlobalVariables } from "../../../../GlobalVariables";

const EmissaoContext = createContext();

const EmissaoContextProvider = ({ children }) => {
  const [nfeId, setNfeId] = useState("");

  /* Lists */
  const [nfeListStockLocation, setNfeListStockLocation] = useState([]);
  const [nfeListNcm, setNfeListNcm] = useState([]);
  const [nfeListCfop, setNfeListCfop] = useState([]);
  const [nfeListBandeiras, setNfeListBandeiras] = useState([]);
  const [nfeListOperadoras, setNfeListOperadoras] = useState([]);
  const [nfeLotes, setNfeLotes] = useState([]);
  const [nfeValidXml, setNfeValidXml] = useState("");
  const [listUf, setListUf] = useState([]);
  const [listCounty, setListCounty] = useState([]);
  const [loadingInputs, setLoadingInputs] = useState({});
  const [montageSelectedItemTaxation, setMontageSelectedItemTaxation] =
    useState({});
  const [loading, setLoading] = useState(false);
  const [cloneLoading, setCloneLoading] = useState(false);
  const [salesOrderLoading, setSalesOrderLoading] = useState(false);

  /*Auxiliar */

  /**
   * MontageSubType = Venda, Devolução, Manual, etc..
   * MontageType = Manual "M" ou Automatica "A"
   */

  const [nfeMontageSubtype, setNfeMontageSubtype] = useState("M");
  const [nfeStatus, setNfeStatus] = useState("D");
  const [nfeMontageType, setNfeMontageType] = useState("M");
  const [nfeFinancialIssue, setNfeFinancialIssue] = useState("");
  const [mainLoading, setMainLoading] = useState(false);
  const [getSeriesLoading, setGetSeriesLoading] = useState(false);
  const [idsCrsMontage, setIdsCrsMontage] = useState([]);
  const [daysCertificate, setDaysCertificate] = useState(0);
  const [nfeSales, setNfeSales] = useState([]);
  const [forceProduction, setForceProduction] = useState(false);
  const [typeMontage, setTypeMontage] = useState("");
  const [openNfeLoading, setOpenNfeLoading] = useState(false);

  const [complementedAccessKey, setComplementedAccessKey] = useState("");

  /* Cabeçalho */

  //LISTS

  const [senderListIndicationIe] = useState([
    {
      label: "Contribuinte ICMS",
      value: 1,
      codigo: "1",
    },
    {
      label: "Contribuinte Isento",
      value: 0,
      codigo: "2",
    },
    {
      label: "Não Contribuinte",
      value: 0,
      codigo: "9",
    },
  ]);

  const [nfeListYesOrNo] = useState([
    { label: "SIM", value: "S" },
    { label: "NÃO", value: "N" },
  ]);

  const [nfeListTypeNf] = useState([
    {
      label: "Entrada",
      value: "E",
    },
    {
      label: "Saida",
      value: "S",
    },
  ]);

  const [nfeListOperations] = useState([
    { label: "Operação interna", value: "1" },
    { label: "Operação interestadual", value: "2" },
    { label: "Operação com exterior", value: "3" },
  ]);

  const [defaultListModels] = useState([
    { label: "Modelo 55", value: "55" },
    { label: "Modelo 65", value: "65" },
  ]);

  const [listModels, setListModels] = useState([]);

  const [nfeListPresentOperations] = useState([
    {
      label:
        "Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)",
      value: "0",
    },
    {
      label: "Presencial",
      value: "1",
    },
    {
      label: "Não presencial, pela Internet",
      value: "2",
    },
    {
      label: "Não presencial, Teleatendimento",
      value: "3",
    },
    {
      label: "NFC-e em operação com entrega a domicílio",
      value: "4",
    },
    {
      label: "Operação presencial, fora do estabelecimento",
      value: "5",
    },
    {
      label: "Não presencial, outros",
      value: "9",
    },
  ]);

  const [nfeListFinnally] = useState([
    { label: "NF-e Normal", value: "1" },
    { label: "NF-e Complementar", value: "2" },
    { label: "NF-e de Ajuste", value: "3" },
    { label: "Devolução de Mercadoria", value: "4" },
  ]);

  const [nfeListIntermed] = useState([
    {
      label: "Operação sem intermediador (em site ou plataforma própria)",
      value: "0",
    },
    {
      label:
        "Operação em site ou plataforma de terceiros (intermediadores/marketplace)",
      value: "1",
    },
  ]);

  const [nfeListReasonIntermed, setNfeListReasonIntermed] = useState([]);

  const [nfeError, setNfeError] = useState({});
  const [headerIssueTime, setHeaderIssueTime] = useState(new Date());
  const [headerTime, setHeaderTime] = useState(new Date());
  const [headerDateJL, setHeaderDateJL] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [headerIssueType, setHeaderIssueType] = useState("");
  const [headerNfe, setHeaderNfe] = useState("");
  const [headerSeries, setHeaderSeries] = useState("");
  const [selectedHeaderSeries, setSelectedHeaderSeries] = useState(null);
  const [headerSeriesOptions, setHeaderSeriesOptions] = useState([]);
  const [headerIssueDate, setHeaderIssueDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [headerDemandNumber, setHeaderDemandNumber] = useState("");
  const [headerAccessKey, setHeaderAccessKey] = useState("");

  const [headerTypeNfe, setHeaderTypeNfe] = useState({
    label: "Saida",
    value: "S",
  });
  const [headerCfop, setHeaderCfop] = useState("");
  const [headerOperationNature, setHeaderOperationNature] = useState("");
  const [headerPresentOperation, setHeaderPresentOperation] = useState({
    label: "Presencial",
    value: "1",
  });
  const [headerFinalCostumer, setHeaderFinalCostumer] = useState({
    label: "SIM",
    value: "S",
  });
  const [headerOperation, setHeaderOperation] = useState({
    label: "Operação interna",
    value: "1",
  });
  const [headerModel, setHeaderModel] = useState(null);
  const [headerFinnally, setHeaderFinnally] = useState({
    label: "NF-e Normal",
    value: "1",
  });
  const [headerIeTax, setHeaderIeTax] = useState("");
  const [headerPurchaseOrder, setHeaderPurchaseOrder] = useState("");
  const [headerPurchaseContract, setHeaderPurchaseContract] = useState("");
  const [headerReasonIntermed, setHeaderReasonIntermed] = useState(null);
  const [headerIndicatorIntermed, setHeaderIndicatorIntermed] = useState(null);
  const [headerIdentifierIntermed, setHeaderIdentifierIntermed] = useState("");
  const [headerIntermedCnpj, setHeaderIntermedCnpj] = useState("");
  const [headerPurchasePublic, setHeaderPurchasePublic] = useState("");

  /* Remetente/Destinatário */
  const [sender, setSender] = useState(null);
  const [senderClifor, setSenderClifor] = useState("C");
  const [senderId, setSenderId] = useState("");
  const [senderIe, setSenderIe] = useState("");
  const [senderCountryCode, setSenderCountryCode] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderCnpj, setSenderCnpj] = useState("");
  const [senderAddress, setSenderAddres] = useState("");
  const [senderComplement, setSenderComplement] = useState("");
  const [senderNumber, setSenderNumber] = useState("");
  const [senderDistrict, setSenderDistrict] = useState("");
  const [senderCity, setSenderCity] = useState("");
  const [senderCityCode, setSenderCityCode] = useState("");
  const [senderUf, setSenderUf] = useState("");
  const [senderUfLabel, setSenderUfLabel] = useState("");
  const [senderCep, setSenderCep] = useState("");
  const [senderPhone, setSenderPhone] = useState("");
  const [senderMail, setSenderMail] = useState("");
  const [senderIndicationIe, setSenderIndicationIe] = useState(null);
  const [isRuralProducerSender, setIsRuralProducerSender] = useState(false);
  const [updateSender, setUpdateSender] = useState(false);

  const [senderCheckBilling, setSenderCheckBilling] = useState(false);
  const [senderBillingAddress, setSenderBillingAddress] = useState("");
  const [senderBillingNumber, setSenderBillingNumber] = useState("");
  const [senderBillingDistrict, setSenderBillingDistrict] = useState("");
  const [senderBillingCity, setSenderBillingCity] = useState(null);
  const [senderBillingUf, setSenderBillingUf] = useState(null);
  const [senderBillingCep, setSenderBillingCep] = useState("");
  const [senderBillingComplement, setSenderBillingComplement] = useState("");

  const [senderCheckDelivery, setSenderCheckDelivery] = useState(false);
  const [senderDeliveryList, setSenderDeliveryList] = useState([]);
  const [senderDeliveryAddress, setSenderDeliveryAddress] = useState("");
  const [senderDeliveryNumber, setSenderDeliveryNumber] = useState("");
  const [senderDeliveryDistrict, setSenderDeliveryDistrict] = useState("");
  const [senderDeliveryCity, setSenderDeliveryCity] = useState("");
  const [senderDeliveryUf, setSenderDeliveryUf] = useState("");
  const [senderDeliveryCep, setSenderDeliveryCep] = useState("");
  const [senderDeliveryCodeCity, setSenderDeliveryCodeCity] = useState("");
  const [senderDeliveryComplement, setSenderDeliveryComplement] = useState("");
  const [senderRuralEstablishmentsList, setSenderRuralEstablishmentsList] =
    useState([]);
  const [senderRuralEstablishment, setSenderRuralEstablishment] =
    useState(null);

  //Auxiliares Destinatario
  const [enableEndereco, setEnableEndereco] = useState(false);
  const [enableBillingEdit, setEnableBillingEdit] = useState(false);
  const [enableDeliveryEdit, setEnableDeliveryEdit] = useState(false);

  /* Itens/Produtos */
  const [itensTable, setItensTable] = useState([]);
  const [deleteItensTable, setDeleteItensTable] = useState([]);

  const [itensTotal, setItensTotal] = useState("0");
  const [itensTotalProductValue, setItensTotalProductValue] = useState("0,00");
  const [itensTotalNfe, setItensTotalNfe] = useState("0,00");

  const [itensTotalValueIcms, setItensTotalValueIcms] = useState("0,00");
  const [itensTotalBaseIcms, setItensTotalBaseIcms] = useState("0,00");
  const [itensTotalIcmsFcp, setItensTotalIcmsFcp] = useState("0,00");
  const [itensTotalIcmsDes, setItensTotalIcmsDes] = useState("0,00");

  const [itensTotalValueSt, setItensTotalValueSt] = useState("0,00");
  const [itensTotalBaseSt, setItensTotalBaseSt] = useState("0,00");
  const [itensTotalStFcp, setItensTotalStFcp] = useState("0,00");
  const [itensTotalStWithheld, setItensTotalStWithheld] = useState("0,00");

  const [itensTotalValueIpi, setItensTotalValueIpi] = useState("0,00");
  const [itensTotalIpiReturned, setItensTotalIpiReturned] = useState("0,00");

  const [itensTotalValuePis, setItensTotalValuePis] = useState("0,00");
  const [itensTotalValueCofins, setItensTotalValueCofins] = useState("0,00");

  const [itensTotalValueCustoms, setItensTotalValueCustoms] = useState("0,00");
  const [itensTotalValueII, setItensTotalValueII] = useState("0,00");

  const [itensTotalFreight, setItensTotalFreight] = useState("0,00");
  const [itensTotalSafe, setItensTotalSafe] = useState("0,00");
  const [itensTotalOthers, setItensTotalOthers] = useState("0,00");
  const [itensTotalDiscount, setItensTotalDiscount] = useState("0,00");

  /* Informações Secundárias (TABS) */

  //Forma de Pagamento
  const [nfeListPaymentMethod] = useState([
    { value: "01", label: "Dinheiro" },
    { value: "02", label: "Cheque" },
    { value: "03", label: "Cartão de Crédito" },
    { value: "04", label: "Cartão de Débito" },
    { value: "05", label: "Crédito de Loja" },
    { value: "10", label: "Vale Alimentação" },
    { value: "11", label: "Vale Refeição" },
    { value: "12", label: "Vale Presente" },
    { value: "13", label: "Vale Combustível" },
    { value: "14", label: "Duplicata Mercantil" },
    { value: "15", label: "Boleto Bancário" },
    { value: "16", label: "Depósito Bancário" },
    { value: "17", label: "Pagamento Instantâneo (PIX)" },
    { value: "18", label: "Transferência bancária, Carteira Digital" },
    { value: "19", label: "Programa de fidelidade, Cashback, Crédito Virtual" },
    { value: "90", label: "Sem pagamento" },
    { value: "99", label: "Outros" },
  ]);
  const [nfeListPaymentIndicator] = useState([
    { value: "0", label: "Pagamento à Vista" },
    { value: "1", label: "Pagamento à Prazo" },
  ]);
  const [nfeListPaymentTypeIntegration] = useState([
    {
      value: "1",
      label:
        "Pagamento integrado com o sistema de automação da empresa (Ex.: equipamento TEF, Comércio Eletrônico)",
    },
    {
      value: "2",
      label:
        "Pagamento não integrado com o sistema de automação da empresa (Ex.: equipamento POS)",
    },
  ]);
  const [pagtoTableCobranca, setPagtoTableCobranca] = useState([]);
  const [pagtoTableFormaPagto, setPagtoTableFormaPagto] = useState([]);
  const [chargeValue, setChargeValue] = useState("0,00");
  const [paymentValue, setPaymentValue] = useState("0,00");

  //Transportadora/Volumes
  const [nfeListModalities] = useState([
    {
      label: "Contratação do Frete por conta do Remetente",
      value: "0",
    },
    {
      label: "Contratação do Frete por conta do Destinatário",
      value: "1",
    },
    {
      label: "Contratação do Frete por conta de Terceiros",
      value: "2",
    },
    {
      label: "Transporte Próprio por conta do Remetente",
      value: "3",
    },
    {
      label: "Transporte Próprio por conta do Destinatário",
      value: "4",
    },
    {
      label: "Sem Ocorrência de Transporte",
      value: "9",
    },
  ]);
  const [transpId, setTranspId] = useState("");
  const [transp, setTransp] = useState(null);
  const [transpModality, setTranspModality] = useState({
    label: "Sem Ocorrência de Transporte",
    value: "9",
  });
  const [transpCnpj, setTranspCnpj] = useState("");
  const [transpName, setTranspName] = useState("");
  const [transpIe, setTranspIe] = useState("");
  const [transpRntc, setTranspRntc] = useState("");
  const [transpAddress, setTranspAddress] = useState("");
  const [transpNumber, setTranspNumber] = useState("");
  const [transpUf, setTranspUf] = useState([]);
  const [transpCity, setTranspCity] = useState([]);
  const [transpCityCode, setTranspCityCode] = useState("");
  const [transpBoardcar, setTranspBoardcar] = useState("");
  const [transpBoardcarUf, setTranspBoardcarUf] = useState("");
  const [transpTableSize, setTranspTableSize] = useState([]);

  //Observações
  const [obsText, setObsText] = useState("");
  const [obsBd, setObsBd] = useState("");
  const [obsTextCreditRate, setObsTextCreditRate] = useState("");
  const [obsTextCFOP, setObsTextCFOP] = useState("");
  const [obsTextComplemento, setObsTextComplemento] = useState("");

  //Documentos Referenciados
  const [docTable, setDocTable] = useState([]);

  //DI
  const [diImpWayOf, setDiImpWayOf] = useState("");

  const [diDeclarationDate, setDiDeclarationDate] = useState("");
  const [diDeclarationUf, setDiDeclarationUf] = useState("");
  const [diDeclarationCity, setDiDeclarationCity] = useState("");
  const [diDeclarationDateDes, setDiDeclarationDateDes] = useState("");
  const [diDeclarationDrawback, setDiDeclarationDrawback] = useState("");
  const [diDeclarationDiNumber, setDiDeclarationDiNumber] = useState("");
  const [diControle, setDiControle] = useState([]);

  const listViaTransporte = [
    { label: "1 - Marítima", value: 1 },
    { label: "2 - Fluvial", value: 2 },
    { label: "3 - Lacustre", value: 3 },
    { label: "4 - Aérea", value: 4 },
    { label: "5 - Postal", value: 5 },
    { label: "6 - Ferroviária", value: 6 },
    { label: "7 - Rodoviária", value: 7 },
    { label: "8 - Conduto / Rede Transmissão", value: 8 },
    { label: "9 - Meios Próprios", value: 9 },
    { label: "10 - Entrada / Saída ficta", value: 10 },
    { label: "11 - Courier", value: 11 },
    { label: "12 - Em mãos", value: 12 },
    { label: "13 - Por reboque", value: 13 },
  ];

  const listCfopFuel = [
    { label: "651", value: 1 },
    { label: "652", value: 2 },
    { label: "653", value: 3 },
    { label: "654", value: 4 },
    { label: "655", value: 5 },
    { label: "656", value: 6 },
    { label: "657", value: 7 },
    { label: "658", value: 8 },
    { label: "659", value: 9 },
    { label: "660", value: 10 },
    { label: "661", value: 11 },
    { label: "662", value: 12 },
    { label: "663", value: 13 },
    { label: "664", value: 14 },
    { label: "665", value: 15 },
    { label: "667", value: 16 },
  ];

  const diIntermediaryTypeList = [
    { label: "Por conta própria", value: 1 },
    { label: "Por conta e ordem", value: 2 },
    { label: "Por encomenda", value: 3 },
  ];

  const [diIntermediaryType, setDiIntermediaryType] = useState({
    label: "Por conta própria",
    value: 1,
  });
  const [diAcquirerUf, setAcquirerUf] = useState(null);
  const [diAcquirerDocument, setAcquirerDocument] = useState("");

  // Estado criado para controlar quando a nota
  // tem os produtos apenas para visualização
  const [visualizationOnly, setVisualizationOnly] = useState(false);
  const [saveBlocked, setSaveBlocked] = useState(false);
  const [firstSaveDiBlock, setFirstSaveDiBlock] = useState(false);
  const [diBlocked, setDiBlocked] = useState(false);

  //TabEmissaoExportacao
  const [exportDispatchLocation, setExportDispatchLocation] = useState("");
  const [exportShipmentLocation, setExportShipmentLocation] = useState("");
  const [ufExport, setUfExport] = useState({});

  // Criado para controlar o switch de financeiro da venda
  const [saleFinanceSwitch, setSaleFinanceSwitch] = useState(false);

  const [consideraObsCredit, setConsideraObsCredit] = useState(false);
  const [nfCloneId, setNfCloneId] = useState(null);

  const [listDocumentType] = useState([
    { label: "CNPJ", documentLength: 18 },
    { label: "CPF", documentLength: 14 },
  ]);

  const [listTaxNoteModel] = useState([
    { label: "NFe - modelo 55", value: "55" },
    { label: "NFC-e - modelo 65", value: "65" },
    { label: "CFe-SAT - modelo 59", value: "59" },
    { label: "NF - modelo 01", value: "01" },
    { label: "NFP - modelo 04", value: "04" },
  ]);

  const [taxNoteRuralProducerModels] = useState([
    GlobalVariables.nfe.models.NF,
    GlobalVariables.nfe.models.NFP,
  ]);
  const [taxNoteDefaultModels] = useState([
    GlobalVariables.nfe.models.NFe,
    GlobalVariables.nfe.models.CFeSAT,
    GlobalVariables.nfe.models.NFCe,
  ]);

  const [firstSearch, setFirstSearch] = useState(true);

  const [xmlAuthorizedList, setXmlAuthorizedList] = useState([]);

  // Estados utilizados nos dados da montagem automatica da nota fiscal de compra
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [selectedPurchaseNf, setSelectedPurchaseNf] = useState([]);
  const [selectedPurchaseItems, setSelectedPurchaseItems] = useState([]);
  const [purchaseStartDate, setPurchaseStartDate] = useState("");
  const [purchaseFinalDate, setPurchaseFinalDate] = useState("");

  const [additionalPaymentsInfo] = useState([
    "03", // Cartão de Crédito
    "04", // Cartão de Débito
    "17", // Pagamento Instantâneo (PIX)
  ]);

  return (
    <EmissaoContext.Provider
      value={{
        daysCertificate,
        setDaysCertificate,
        nfeMontageType,
        setNfeMontageType,
        nfeStatus,
        setNfeStatus,
        mainLoading,
        setMainLoading,
        getSeriesLoading,
        setGetSeriesLoading,
        loading,
        setLoading,
        cloneLoading,
        setCloneLoading,
        nfeId,
        setNfeId,
        nfeListStockLocation,
        setNfeListStockLocation,
        nfeListBandeiras,
        setNfeListBandeiras,
        nfeListPaymentMethod,
        nfeListPaymentIndicator,
        nfeListPaymentTypeIntegration,
        nfeListTypeNf,
        nfeListOperations,
        listModels,
        setListModels,
        defaultListModels,
        nfeListPresentOperations,
        nfeListNcm,
        nfeListFinnally,
        nfeListYesOrNo,
        nfeListModalities,
        nfeLotes,
        nfeListIntermed,
        setNfeLotes,
        setNfeListNcm,
        nfeFinancialIssue,
        setNfeFinancialIssue,
        nfeError,
        setNfeError,
        nfeListCfop,
        setNfeListCfop,
        headerIssueType,
        setHeaderIssueType,
        headerNfe,
        setHeaderNfe,
        headerSeries,
        setHeaderSeries,
        selectedHeaderSeries,
        setSelectedHeaderSeries,
        headerSeriesOptions,
        setHeaderSeriesOptions,
        headerIssueDate,
        setHeaderIssueDate,
        headerDemandNumber,
        setHeaderDemandNumber,
        headerAccessKey,
        setHeaderAccessKey,
        headerTypeNfe,
        setHeaderTypeNfe,
        headerCfop,
        setHeaderCfop,
        headerOperationNature,
        setHeaderOperationNature,
        headerPresentOperation,
        setHeaderPresentOperation,
        headerFinalCostumer,
        setHeaderFinalCostumer,
        headerOperation,
        setHeaderOperation,
        headerFinnally,
        setHeaderFinnally,
        headerIeTax,
        setHeaderIeTax,
        headerPurchaseOrder,
        setHeaderPurchaseOrder,
        headerPurchaseContract,
        setHeaderPurchaseContract,
        sender,
        setSender,
        senderUfLabel,
        setSenderUfLabel,
        senderClifor,
        senderIe,
        setSenderIe,
        setSenderClifor,
        senderId,
        setSenderId,
        senderCountryCode,
        setSenderCountryCode,
        senderName,
        setSenderName,
        senderCnpj,
        setSenderCnpj,
        senderAddress,
        setSenderAddres,
        senderComplement,
        setSenderComplement,
        senderNumber,
        setSenderNumber,
        senderDistrict,
        setSenderDistrict,
        senderCity,
        setSenderCity,
        senderCityCode,
        setSenderCityCode,
        senderUf,
        setSenderUf,
        senderCep,
        setSenderCep,
        senderPhone,
        setSenderPhone,
        senderMail,
        setSenderMail,
        senderCheckBilling,
        setSenderCheckBilling,
        senderBillingAddress,
        setSenderBillingAddress,
        senderBillingNumber,
        setSenderBillingNumber,
        senderBillingDistrict,
        setSenderBillingDistrict,
        senderBillingCity,
        setSenderBillingCity,
        senderBillingUf,
        setSenderBillingUf,
        senderBillingCep,
        setSenderBillingCep,
        senderBillingComplement,
        setSenderBillingComplement,
        senderCheckDelivery,
        setSenderCheckDelivery,
        senderDeliveryList,
        setSenderDeliveryList,
        senderDeliveryAddress,
        setSenderDeliveryAddress,
        senderDeliveryNumber,
        setSenderDeliveryNumber,
        senderDeliveryDistrict,
        setSenderDeliveryDistrict,
        senderDeliveryCity,
        setSenderDeliveryCity,
        senderDeliveryUf,
        setSenderDeliveryUf,
        senderDeliveryCep,
        setSenderDeliveryCep,
        senderDeliveryComplement,
        setSenderDeliveryComplement,
        senderDeliveryCodeCity,
        setSenderDeliveryCodeCity,
        senderRuralEstablishmentsList,
        setSenderRuralEstablishmentsList,
        senderRuralEstablishment,
        setSenderRuralEstablishment,
        itensTable,
        setItensTable,
        deleteItensTable,
        setDeleteItensTable,
        itensTotalValueIcms,
        setItensTotalValueIcms,
        itensTotalBaseIcms,
        setItensTotalBaseIcms,
        itensTotalIcmsFcp,
        setItensTotalIcmsFcp,
        itensTotalIcmsDes,
        setItensTotalIcmsDes,
        itensTotalValueSt,
        setItensTotalValueSt,
        itensTotalBaseSt,
        setItensTotalBaseSt,
        itensTotalStFcp,
        setItensTotalStFcp,
        itensTotalStWithheld,
        setItensTotalStWithheld,
        itensTotalValueIpi,
        setItensTotalValueIpi,
        itensTotalIpiReturned,
        setItensTotalIpiReturned,
        itensTotalValuePis,
        setItensTotalValuePis,
        itensTotalValueCofins,
        setItensTotalValueCofins,
        itensTotalValueCustoms,
        setItensTotalValueCustoms,
        itensTotalValueII,
        setItensTotalValueII,
        itensTotalFreight,
        setItensTotalFreight,
        itensTotalSafe,
        setItensTotalSafe,
        itensTotalOthers,
        setItensTotalOthers,
        itensTotalDiscount,
        setItensTotalDiscount,
        itensTotal,
        setItensTotal,
        itensTotalProductValue,
        setItensTotalProductValue,
        itensTotalNfe,
        setItensTotalNfe,
        pagtoTableCobranca,
        setPagtoTableCobranca,
        pagtoTableFormaPagto,
        setPagtoTableFormaPagto,
        paymentValue,
        setPaymentValue,
        chargeValue,
        setChargeValue,
        transp,
        setTransp,
        transpId,
        setTranspId,
        transpCityCode,
        setTranspCityCode,
        transpModality,
        setTranspModality,
        transpCnpj,
        setTranspCnpj,
        transpName,
        setTranspName,
        transpIe,
        setTranspIe,
        transpRntc,
        setTranspRntc,
        transpAddress,
        setTranspAddress,
        transpUf,
        setTranspUf,
        transpCity,
        setTranspCity,
        transpBoardcar,
        setTranspBoardcar,
        transpBoardcarUf,
        setTranspBoardcarUf,
        transpTableSize,
        setTranspTableSize,
        obsText,
        setObsText,
        obsBd,
        setObsBd,
        obsTextCreditRate,
        setObsTextCreditRate,
        obsTextCFOP,
        setObsTextCFOP,
        obsTextComplemento,
        setObsTextComplemento,
        docTable,
        setDocTable,
        diImpWayOf,
        setDiImpWayOf,
        diDeclarationDate,
        setDiDeclarationDate,
        diDeclarationDiNumber,
        setDiDeclarationDiNumber,
        diControle,
        setDiControle,
        diDeclarationUf,
        setDiDeclarationUf,
        diDeclarationCity,
        setDiDeclarationCity,
        diDeclarationDateDes,
        setDiDeclarationDateDes,
        diDeclarationDrawback,
        setDiDeclarationDrawback,
        listViaTransporte,
        listCfopFuel,
        diIntermediaryTypeList,
        diIntermediaryType,
        setDiIntermediaryType,
        diAcquirerUf,
        setAcquirerUf,
        diAcquirerDocument,
        setAcquirerDocument,
        idsCrsMontage,
        setIdsCrsMontage,
        nfeListReasonIntermed,
        setNfeListReasonIntermed,
        headerIndicatorIntermed,
        setHeaderIndicatorIntermed,
        headerIdentifierIntermed,
        setHeaderIdentifierIntermed,
        headerIntermedCnpj,
        setHeaderIntermedCnpj,
        headerReasonIntermed,
        setHeaderReasonIntermed,
        nfeSales,
        setNfeSales,
        headerTime,
        setHeaderTime,
        headerDateJL,
        setHeaderDateJL,
        headerIssueTime,
        setHeaderIssueTime,
        senderListIndicationIe,
        senderIndicationIe,
        setSenderIndicationIe,
        updateSender,
        setUpdateSender,
        nfeMontageSubtype,
        setNfeMontageSubtype,
        forceProduction,
        setForceProduction,
        typeMontage,
        setTypeMontage,
        nfeValidXml,
        setNfeValidXml,
        enableEndereco,
        setEnableEndereco,
        enableBillingEdit,
        setEnableBillingEdit,
        enableDeliveryEdit,
        setEnableDeliveryEdit,
        listUf,
        setListUf,
        listCounty,
        setListCounty,
        loadingInputs,
        setLoadingInputs,
        montageSelectedItemTaxation,
        setMontageSelectedItemTaxation,
        transpNumber,
        setTranspNumber,
        visualizationOnly,
        setVisualizationOnly,
        saveBlocked,
        setSaveBlocked,
        diBlocked,
        setDiBlocked,
        headerPurchasePublic,
        setHeaderPurchasePublic,
        nfeListOperadoras,
        setNfeListOperadoras,
        complementedAccessKey,
        setComplementedAccessKey,
        firstSaveDiBlock,
        setFirstSaveDiBlock,
        exportDispatchLocation,
        setExportDispatchLocation,
        exportShipmentLocation,
        setExportShipmentLocation,
        ufExport,
        setUfExport,
        consideraObsCredit,
        setConsideraObsCredit,
        saleFinanceSwitch,
        setSaleFinanceSwitch,
        listDocumentType,
        xmlAuthorizedList,
        setXmlAuthorizedList,
        nfCloneId,
        setNfCloneId,
        isRuralProducerSender,
        setIsRuralProducerSender,
        listTaxNoteModel,
        taxNoteDefaultModels,
        taxNoteRuralProducerModels,
        selectedSupplier,
        setSelectedSupplier,
        selectedPurchaseNf,
        setSelectedPurchaseNf,
        selectedPurchaseItems,
        setSelectedPurchaseItems,
        purchaseStartDate,
        setPurchaseStartDate,
        purchaseFinalDate,
        setPurchaseFinalDate,
        firstSearch,
        setFirstSearch,
        headerModel,
        setHeaderModel,
        salesOrderLoading,
        setSalesOrderLoading,
        openNfeLoading,
        setOpenNfeLoading,
        additionalPaymentsInfo,
      }}
    >
      {children}
    </EmissaoContext.Provider>
  );
};

export { EmissaoContextProvider, EmissaoContext };
